export type ImpostoTipo = 'COFINS' | 'CSLL' | 'INSS' | 'IRRF' | 'PIS' | 'ISS';

export const IMPOSTO_TIPOS: ReadonlyArray<{ value: ImpostoTipo; label: string }> = [
  { value: 'COFINS', label: 'COFINS' },
  { value: 'CSLL', label: 'CSLL' },
  { value: 'INSS', label: 'INSS' },
  { value: 'IRRF', label: 'IRRF' },
  { value: 'PIS', label: 'PIS' },
  { value: 'ISS', label: 'ISS' },
];

/** Domain `RegraMunicipal` VarChar(3) — 3 valores. */
export type RegraMunicipal = 'MES' | 'OUT' | 'AMB';

export const REGRAS_MUNICIPAIS: ReadonlyArray<{ value: RegraMunicipal; label: string }> = [
  { value: 'MES', label: 'Mesmo município' },
  { value: 'OUT', label: 'Outro município' },
  { value: 'AMB', label: 'Ambos' },
];

export interface ImpostoDto {
  id: number;
  tipo: ImpostoTipo;
  regraMunicipal: RegraMunicipal | null;
  aliquota: number; // percentual direto (ex.: 3.5 = 3,5%); Numeric(8,4) no KB
  nome: string;
  retido: boolean;
  empresaId: number;
  empresaNome: string;
  enviarValor: boolean;
  enviarAliquota: boolean;
  ativo: boolean;
  excluidoEm: string | null;
  excluidoPorGuid: string | null;
  excluidoPorNome: string | null;
  criadoEm: string;
  criadoPorGuid: string;
  criadoPorNome: string;
  atualizadoEm: string | null;
  atualizadoPorGuid: string | null;
  atualizadoPorNome: string;
}

export interface ImpostoListItem {
  id: number;
  nome: string;
  tipo: ImpostoTipo;
  aliquota: number;
  empresaNome: string;
  ativo: boolean;
}

export interface ImpostoInput {
  tipo: ImpostoTipo;
  regraMunicipal?: RegraMunicipal | null;
  aliquota: number;
  nome: string;
  retido: boolean;
  empresaId: number;
  enviarValor: boolean;
  enviarAliquota: boolean;
  ativo?: boolean;
}
